import React from 'react';
import { useWallet } from '@/hooks/useWallet';
import { NETWORK_CONFIG } from '@/lib/contracts/config';
import Button from '@/components/ui/Button';

export const NetworkBadge: React.FC = () => {
  const { chainId, isConnected, switchNetwork } = useWallet();

  if (!isConnected) {
    return null;
  }

  // Normalize chainId to a number for reliable comparison
  const expectedChainId = NETWORK_CONFIG.chainId; // numeric: 420420422

  // Convert chainId to number regardless of format (hex string, decimal string, etc.)
  let currentChainIdNum: number | null = null;
  if (chainId) {
    if (chainId.startsWith('0x')) {
      currentChainIdNum = parseInt(chainId, 16);
    } else {
      currentChainIdNum = parseInt(chainId, 10);
    }
  }

  const isCorrectNetwork = currentChainIdNum === expectedChainId;

  // Debug logging (can be removed later)
  console.log('[NetworkBadge] chainId:', chainId, '-> parsed:', currentChainIdNum, 'expected:', expectedChainId, 'isCorrect:', isCorrectNetwork);

  if (isCorrectNetwork) {
    return (
      <div className="flex items-center gap-2 ff-border px-3 py-2 bg-[#0f3460]">
        <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
        <span className="text-pixel-sm">{NETWORK_CONFIG.name}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 ff-border px-3 py-2 bg-[#d32f2f]">
        <div className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse" />
        <span className="text-pixel-sm">Wrong Network</span>
      </div>
      <Button variant="danger" size="sm" onClick={switchNetwork}>
        Switch to Paseo
      </Button>
    </div>
  );
};

export default NetworkBadge;
